import { motion } from "framer-motion";
import { Phone, Sparkles } from "lucide-react";
import { Reveal, RevealLines } from "./Reveal";
import { BRAND } from "../../lib/brand";

const LOGO = "/images/logo-full.webp";

export default function FinalCTA() {
  return (
    <section
      id="contact"
      className="relative bg-cream overflow-hidden"
      data-testid="final-cta-section"
    >
      <div className="relative mx-auto max-w-[1500px] px-6 md:px-10 py-24 md:py-40 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        {/* Left: text */}
        <div className="md:col-span-7">
          <Reveal>
            <div className="inline-flex items-center gap-2 text-gold text-[11px] uppercase tracking-[0.3em]">
              <Sparkles className="h-3.5 w-3.5" strokeWidth={1.4} />
              Offre première séance
            </div>
          </Reveal>

          <RevealLines
            lines={["Offrez à votre corps", "le soin qu'il"]}
            delayBase={0.1}
            className="mt-8 font-serif text-olive text-5xl md:text-7xl lg:text-[7.5rem] leading-[0.95] tracking-tighter"
          />
          <RevealLines
            lines={["mérite vraiment."]}
            delayBase={0.35}
            className="font-serif text-gold text-5xl md:text-7xl lg:text-[7.5rem] leading-[0.95] tracking-tighter"
          />

          <Reveal delay={0.5}>
            <p className="mt-10 text-olive/75 text-[16px] leading-[1.7] font-light max-w-[520px]">
              Réservez cette semaine votre première séance.
            </p>
          </Reveal>

          <Reveal delay={0.65}>
            <div className="mt-12">
              <a
                href={BRAND.phoneHref}
                data-testid="cta-final-reserve"
                className="btn-gold inline-flex items-center gap-3 px-10 py-5 text-[12px] uppercase tracking-[0.24em] rounded-full"
              >
                <Phone className="h-4 w-4" strokeWidth={1.6} />
                Je réserve ma séance
              </a>
            </div>
          </Reveal>
        </div>

        {/* Right: logo */}
        <div className="md:col-span-5 flex items-center justify-center">
          <motion.img
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            src={LOGO}
            alt="Corps & Sens — logo"
            className="w-full max-w-[520px] h-auto object-contain select-none pointer-events-none"
            loading="lazy"
            draggable="false"
          />
        </div>
      </div>
    </section>
  );
}
